import { FunctionComponent } from "react";
import styles from "./JoinSpeakerInfoScreen.module.css";

const JoinSpeakerInfoScreen: FunctionComponent = () => {
  return (
    <div className={styles.joinSpeakerInfoScreen}>
      <div className={styles.masterScreen}>
        <div className={styles.masterScreenChild} />
        <div className={styles.masterScreenItem} />
        <div className={styles.byManaberaiAllRightsContainer}>
          © 2025  by
          <a
            className={styles.manaberai}
            href="https://themeforest.net/user/ib-themes"
            target="_blank"
          >
            <span className={styles.manaberai1}>manaber.ai</span>
          </a>
          . All rights reserved.
        </div>
        <img
          className={styles.manaberlogoCopy3}
          alt=""
          src="/manaberlogo--copy-3@2x.png"
        />
        <img className={styles.govOfShj3Icon} alt="" src="/govofshj-3@2x.png" />
      </div>
      <div className={styles.speaker}>
        <div className={styles.speakerChild} />
        <div className={styles.buttonJoinConference}>
          <img className={styles.vectorIcon} alt="" src="/vector10.svg" />
          <div className={styles.joinConference}>Join conference</div>
        </div>
        <b className={styles.speaker1}>Speaker</b>
        <div className={styles.textfiledSpeakerEnableMicro}>
          <div className={styles.textfiledSpeakerEnableMicroChild} />
          <div className={styles.enableMicrofon}>Enable microfon</div>
          <img className={styles.icons8Microphone481} alt="" src="/icons8microphone48-1@2x.png" />
        </div>
        <div className={styles.textfiledSpeakerPassword}>
          <div className={styles.textfiledSpeakerPasswordChild} />
          <div className={styles.textfiledSpeakerPasswordItem} />
          <div className={styles.password}>Password</div>
          <div className={styles.div}>**************</div>
          <img className={styles.image49Icon} alt="" src="/image-49@2x.png" />
        </div>
        <div className={styles.textfiledSpeakerName}>
          <div className={styles.textfiledSpeakerPasswordChild} />
          <div className={styles.textfiledSpeakerNameItem} />
          <div className={styles.name}>Name</div>
          <div className={styles.div}>Ali</div>
        </div>
        <img className={styles.image51Icon} alt="" src="/image-51@2x.png" />
      </div>
      <img className={styles.image52Icon} alt="" src="/image-52@2x.png" />
      <div className={styles.enableMicrofon1}>Enable microfon</div>
    </div>
  );
};

export default JoinSpeakerInfoScreen;
